import clone from "lodash/clone";
import isNumber from "lodash/isNumber";
import setWith from "lodash/setWith";
import React, { Component } from "react";
import Swal from "sweetalert2";
import { ActivityRegistration } from "./components";
import { DesignContext } from "./core/Design";
import AutomaticFields from "./fields/AutomaticFields";
import FormFields from "./fields/FormFields";
import { formFields } from "./formFields";
import Styles from "./Styles";
// import logo from "./assets/logo-hermes-blanc.png";
// import logo from "./assets/logo-hermes-200.png";
import { hasProducts, initializeData } from "./utils";
import Images from "./utils/Images";
import { getPrices } from "./utils/payment";

// Inject formFields on FormFields
FormFields.formFields = formFields;

// import { Elements, injectStripe } from "react-stripe-elements";

// Vérifier le formulaire sur IE => IE11

let fields, automaticFields;
let options = {};
let design = {
  primaryColor: "#FD5E0F",
};
let activeTab = undefined;

if (window.__DATA__) {
  const data = window.__DATA__;
  if (data.fields) {
    fields = data.fields;
  }
  if (data.automaticFields) {
    automaticFields = data.automaticFields;
  }
  if (data.design) {
    design = data.design;
  }
  if (data.options) {
    options = data.options;
  }
  if (data.activeTab) {
    activeTab = data.activeTab;
  }
}
export function setIn(object, path, value) {
  return setWith(clone(object), path, value, clone);
}

/**
 * Used to inject total/deposit prices in the form, as displayed by recap tables
 */
class PriceInjector extends Component {
  render() {
    const { fields, data, stripeToken } = this.props;

    const userCount = (data.users && data.users.length) || 1;
    const { total, deposit } = getPrices(fields, data, userCount);

    return (
      <div style={{ display: "none" }}>
        <input name="payment[totalValue]" value={total} />
        <input name="payment[depositValue]" value={deposit} />
        {/* TODO : clean up this part... */}
        {stripeToken && data.paymentType === "cb" && <input name="payment[stripeToken]" value={stripeToken} />}
        {/* {stripeToken && data.paymentType === "cb" && (
          <input name="payment[stripeToken]" value={JSON.stringify(stripeToken)} />
        )} */}
      </div>
    );
  }
}

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: initializeData(fields),
      fields,
      automaticFields,
      hasProducts: hasProducts(fields),
      stripeToken: null,
      errors: {},
    };
  }

  formRef = React.createRef();

  componentDidMount() {
    // this.props.stripe.redirectToCheckout({
    //   sessionId: 'cs_test_uHyAgfwEVjS2rXL1WM8GfEgO00mxJFhoZKH0eiClx8oC49jEXf7UDDKP',
    // }).then(function (result) {
    //   console.log("result", result)
    //   // If `redirectToCheckout` fails due to a browser or network
    //   // error, display the localized error message to your customer
    //   // using `result.error.message`.
    // });

    window.addEventListener(
      "message",
      (event) => {
        const data = event.data;
        if (!data.fields && !isNumber(data.activeTab)) return; // Block, invalid message
        if (data.fields) {
          fields = data.fields;
        }
        if (data.design) {
          design = data.design;
        }
        if (isNumber(data.activeTab)) {
          activeTab = data.activeTab;
        }

        // Merge default state + entered data
        this.setState({
          data: { ...initializeData(fields), ...this.state.data },
          fields,
          hasProducts: hasProducts(fields),
          errors: {},
          activeTab,
        });
      },
      false
    );
  }

  onChange = (fieldName, value) => {
    // console.log("onChange", fieldName, value);
    this.setState((state) => ({
      data: setIn(state.data, fieldName, value),
    }));
  };

  setSubmitDisabled = (value) => {
    const submitBtn = document.querySelectorAll("button.af-form-button[type=submit]")[0];
    if (submitBtn) {
      submitBtn.disabled = value;
    }
  };

  disableSubmitTemporarily = () => {
    this.setSubmitDisabled(true);
    // Restore button in 2 seconds (just in case)
    setTimeout(() => this.setSubmitDisabled(false), 2000);
  };

  handleSubmit = async (e) => {
    const { alertConfirmMessage, alertOptions = {} } = options;
    if (alertConfirmMessage) {
      e.preventDefault();
      const result = await Swal.fire({
        title: alertConfirmMessage,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: design.primaryColor,
        cancelButtonColor: "#aaa",
        confirmButtonText: "Confirmer",
        cancelButtonText: "Annuler",
        ...alertOptions,
      });
      if (result.value) {
        this.formRef.current.submit();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    } else {
      this.disableSubmitTemporarily();
    }
  };

  // handleSubmit = async ev => {
  //   const { data } = this.state;
  //   if (data.paymentType !== "cb" || data.stripeToken) {
  //     return; // Normal submit...
  //   }

  //   ev.preventDefault();
  //   ev.stopPropagation();
  //   const { stripe } = this.props;
  //   if (stripe) {
  //     const { payment, email } = data;
  //     const payload = await stripe.createToken({
  //       type: "card",
  //       email,
  //       name: payment ? `${payment.firstName || ""} ${payment.lastName || ""}`.trim() : undefined
  //     });
  //     console.log("[token]", payload);
  //     if (payload && !payload.error && payload.token) {
  //       const { token } = payload;
  //       this.setState(
  //         {
  //           stripeToken: token.id
  //         },
  //         () => {
  //           // Manual submit...
  //           // console.log("time to submit");
  //           this.formRef.current.submit();
  //         }
  //       );
  //     } else {
  //       // ERROR...
  //       console.error(payload);
  //     }
  //   } else {
  //     console.log("Stripe.js hasn't loaded yet.");
  //   }
  // };

  updateFields = (fields) => this.setState({ fields });

  handleConfirm = () => {
    /* const { data } = this.state;

    function extractRequiredFields(fields) {
      if (!fields) return [];

      let requiredFields = [];
      for (const field of fields) {
        if (field.required) {
          requiredFields.push(field);
        }
        if (field.type === "Fields") {
          requiredFields = [...requiredFields, ...extractRequiredFields(field.fields)];
        }
      }
      return requiredFields;
    }

    const requiredFields = extractRequiredFields(fields);
    const invalidFields = {};
    requiredFields.forEach(field => {
      const isValid = data[field.name] && data[field.name].length > 0;
      if (!isValid) {
        invalidFields[field.name] = "Required field";
      }
    });
    this.setState({ errors: invalidFields });*/
  };

  render() {
    const { data, stripeToken, fields, automaticFields, errors, hasProducts, activeTab } = this.state;
    const { header, backgroundImage } = design;
    const submitUrl = window.__DATA__ && window.__DATA__.submitUrl;
    ActivityRegistration.fields = fields; // TODO : use store
    ActivityRegistration.updateFields = this.updateFields; // TODO : use store

    return (
      <div>
        <Styles {...design} />
        <DesignContext.Provider value={design}>
          {backgroundImage && backgroundImage.uri && <div className="af-container__background" />}
          <form
            ref={this.formRef}
            className="af-form-container"
            method="post"
            action={submitUrl}
            onSubmit={this.handleSubmit}
          >
            {header && (
              <div className="af-form-header">
                <img src={Images.maxWidth(header.uri, 1200)} alt="" />
              </div>
            )}
            <div className="af-form-fields-container">
              <AutomaticFields data={data} automaticFields={automaticFields} />
              <FormFields fields={fields} onChange={this.onChange} data={data} errors={errors} activeTab={activeTab} />
            </div>
            {hasProducts && <PriceInjector fields={fields} data={data} stripeToken={stripeToken} />}
          </form>
        </DesignContext.Provider>
      </div>
    );
  }
}

export default Form;
// export default injectStripe(Form);
